(function () {

  'use strict';

  eclipseApp.factory('prepaidAutoRefillInfoService', function() {

    var autoPayPlanEligibility = null,
      autoRefillBalanceEligibility = null,
      autoPayPlanInfo = null,
      autoRefillBalanceInfo = null,
      autoPayPlanSubContent = null,
      autoRefillBalanceSubContent = null,
      autoPayPlanContentClass = null,
      autoRefillBalanceContentClass = null,
      stopAutoPaymentResponse = null;

    function setAutoPayPlanEligibility(data) {
      autoPayPlanEligibility = data;
    }

    function getAutoPayPlanEligibility() {
      return autoPayPlanEligibility;
    }

    function setAutoRefillBalanceEligibility(data) {
      autoRefillBalanceEligibility = data;
    }

    function getAutoRefillBalanceEligibility() {
      return autoRefillBalanceEligibility;
    }

    function setAutoPayPlanInfo(data) {
      autoPayPlanInfo = data;
    }

    function getAutoPayPlanInfo() {
      return autoPayPlanInfo;
    }

    function setAutoRefillBalanceInfo(data) {
      autoRefillBalanceInfo = data;
    }

    function getAutoRefillBalanceInfo() {
      return autoRefillBalanceInfo;
    }

    function setAutoPayPlanSubContent(data) {
      autoPayPlanSubContent = data;
    }

    function getAutoPayPlanSubContent() {
      return autoPayPlanSubContent;
    }

    function setAutoRefillBalanceSubContent(data) {
      autoRefillBalanceSubContent = data;
    }

    function getAutoRefillBalanceSubContent() {
      return autoRefillBalanceSubContent;
    }

    function setAutoPayPlanContentClass(data) {
      autoPayPlanContentClass = data;
    }

    function getAutoPayPlanContentClass() {
      return autoPayPlanContentClass;
    }

    function setAutoRefillBalanceContentClass(data) {
      autoRefillBalanceContentClass = data;
    }

    function getAutoRefillBalanceContentClass() {
      return autoRefillBalanceContentClass;
    }

    function setStopAutoPaymentResponse(data) {
      stopAutoPaymentResponse = data;
    }

    function getStopAutoPaymentResponse() {
      return stopAutoPaymentResponse;
    }

    return {
      setAutoPayPlanEligibility: setAutoPayPlanEligibility,
      getAutoPayPlanEligibility: getAutoPayPlanEligibility,
      setAutoRefillBalanceEligibility: setAutoRefillBalanceEligibility,
      getAutoRefillBalanceEligibility: getAutoRefillBalanceEligibility,
      setAutoPayPlanInfo: setAutoPayPlanInfo,
      getAutoPayPlanInfo: getAutoPayPlanInfo,
      setAutoRefillBalanceInfo: setAutoRefillBalanceInfo,
      getAutoRefillBalanceInfo: getAutoRefillBalanceInfo,
      setAutoPayPlanSubContent: setAutoPayPlanSubContent,
      getAutoPayPlanSubContent: getAutoPayPlanSubContent,
      setAutoRefillBalanceSubContent: setAutoRefillBalanceSubContent,
      getAutoRefillBalanceSubContent: getAutoRefillBalanceSubContent,
      setAutoPayPlanContentClass: setAutoPayPlanContentClass,
      getAutoPayPlanContentClass: getAutoPayPlanContentClass,
      setAutoRefillBalanceContentClass: setAutoRefillBalanceContentClass,
      getAutoRefillBalanceContentClass: getAutoRefillBalanceContentClass,
      setStopAutoPaymentResponse: setStopAutoPaymentResponse,
      getStopAutoPaymentResponse: getStopAutoPaymentResponse
    };

  });

})();
